var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"size":"lg","hide-header":"","hide-footer":"","content-class":"m-0 p-0","body-class":"m-0 p-0"}},[_c('loader',{staticClass:"m-0"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }